module.exports = __webpack_public_path__ + "static/media/SadArtboarde4e0c7a7.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/icons/categories/SadArtboard.svg
// module id = 1308
// module chunks = 0